import React, { Component } from "react";
import { Div, Text, Image, Button, Row, Col } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";
import { Anchor } from "atomize/dist";
import PrimaryButton from "../common/PrimaryButton";

export default class CampaignPhone extends Component {
  render() {
    const { content, imageMobile } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div m={{ t: "6.4rem" }} className="solutions">
            <Row>
              <Col size={{ xs: "12", md: "6" }}>
                <Div>
                  <ImageLink link={content.imgMobileLink}>
                    <Div
                      d={{ xs: "block", md: "none" }}
                      bgImg={content.imgMobile}
                      p={{ b: "100%" }}
                      bgSize="cover"
                      bgRepeat="no-repeat"
                      bgPos="center"
                    ></Div>
                  </ImageLink>
                  <ImageLink link={content.imgPCLink}>
                    <Div
                      d={{ xs: "none", md: "block" }}
                      bgImg={content.imgPC}
                      p={{ b: "141.7%" }}
                      m={{ r: "3rem" }}
                      bgSize="contain"
                      bgRepeat="no-repeat"
                      bgPos="center"
                    ></Div>
                  </ImageLink>
                </Div>
              </Col>
              <Col
                size={{ xs: "12", md: "6" }}
                p={{ l: { xs: "1rem", md: "0", lg: "1rem" } }}
              >
                <Div
                  d="flex"
                  m={{ t: { xs: "1.5rem", md: "0" } }}
                  flexDir="column"
                  justify="center"
                  p={{ l: { xs: "1rem", md: "0", lg: "1.5rem" }, r: "2rem" }}
                  h="100%"
                >
                  <Text
                    textSize="title2"
                    tag="h2"
                    textWeight="700"
                    m={{ b: ".8rem" }}
                  >
                    {content.heading}
                  </Text>
                  <Text
                    className="sub-text"
                    textSize={{ xs: "15px", md: "paragraph" }}
                    textColor="#D9D9D9"
                  >
                    {content.text}
                  </Text>
                  <Div
                    d="flex"
                    align={{ md: "flex-start" }}
                    flexDir={{ xs: "column", md: "row" }}
                    m={{ t: "1.5rem" }}
                    className="hero-swiper-content"
                    textAlign="center"
                  >
                    <AnimateLink to={content.buttonLink}>
                      <PrimaryButton
                        className="hero-action-btn secondary campaign"
                        bg="white"
                        fontFamily="primary"
                        hoverBg="lightGray"
                        w="100%"
                        h="3.125rem"
                        textColor="black"
                        textWeight="800"
                        textTransform="none"
                        border="none"
                        onClick={
                          () =>
                            (window.location.href =
                              "https://trend.io/product-tour")
                          // hero.hero.heroBtnSecondary.link
                        }
                      >
                        {/* {hero.hero.heroBtnSecondary.text} */}
                        Watch Live Demo
                      </PrimaryButton>
                      {/* <Button
                        m={{ r: ".7rem", b: { xs: "1.25rem", md: "0" } }}
                        fontFamily="secondary"
                        textWeight="700"
                        h="3.125rem"
                        p={{ x: "1.4rem" }}
                        bg="primary"
                        hoverBg="primary"
                        rounded="xs"
                        textColor="black"
                      >
                        {content.button}
                      </Button> */}
                    </AnimateLink>
                    <Anchor href={content.appStoreLink}>
                      <Image
                        m={{ l: { md: ".5rem" } }}
                        src={content.appStoreImg}
                        alt={content.alt && content.alt}
                        w="11.25rem"
                        h="3.125rem"
                      />
                    </Anchor>
                  </Div>
                </Div>
              </Col>
            </Row>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
